import { offerActionGroupPolicies } from './offerActionEditRights'
import { offerBookingGroupPolicies } from './offerBookingEditRights'
import { offerQuotationGroupPolicies } from './offerQuotationEditRights'
import { offerSourcingGroupPolicies } from './offerSourcingEditRight'
import { offerGCPRGroupPolicies } from './offerGCPREditRight'

export const allOfferGroupPolicies = {
  ...offerQuotationGroupPolicies,
  ...offerBookingGroupPolicies,
  ...offerSourcingGroupPolicies,
  ...offerActionGroupPolicies,
  ...offerGCPRGroupPolicies,
}
